import * as ReactDOM from 'react-dom';
import type {ReactNode} from 'react'

interface BodyEndProps {
    children: ReactNode
}

export default function BodyEnd({children}: BodyEndProps) {
    return ReactDOM.createPortal(children, document.getElementById('popup-root') || document.body)
}
